/* eslint-disable react/no-deprecated */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import padStart from 'lodash/padStart';
import { SET_PAGE_CACHE } from 'yoda-app-shell/lib/actionTypes/CacheActionTypes';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { isFeatureEnabledFromCookie } from 'yoda-core-components/lib/helpers/Utils/Utils';
import MiniPDPInterstitialAsync from 'yoda-mini-pdp/lib/components/MiniPDPInterstitial/MiniPDPInterstitialAsync';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import productDetailsAction from 'yoda-site-components/lib/actions/ProductDetailsAction';
import { resetInventoryAction } from 'yoda-site-components/lib/actions/InventoryAction';
import {
    selectSizeBasedOnDeviceType,
    selectDeviceType,
    selectShouldRender,
    selectDeviceName,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import selectProductType from 'yoda-site-components/lib/selectors/productDetails/selectProductType';
import { selectQueryParams } from 'yoda-site-components/lib/selectors/QuerySelector';
import { showLazy } from 'yoda-site-components/lib/lazy/actions/LazyAction';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { productOptionsOnResetAction } from 'yoda-site-components/lib/actions/ProductOptionsAction';
import { getUserEmailFromApp } from 'yoda-site-components/lib/actions/NativeAppAction';
import { DP_USER_EMAIL } from 'yoda-site-components/lib/helpers/myAlerts/getMyALertsEmailId';
import { isPLAPage } from 'yoda-site-components/lib/helpers/Utils/PLAHelper';
import { DP_USER_STATE } from 'yoda-site-components/lib/common/Constants';
import ShippingProtectionModalLazy from 'yoda-checkout-components/lib/components/ShippingProtection/ShippingProtectionModalLazy';
import getQueryParams from '../../../actions/QueryParamsAction';
import { updateStoreCookieFromPLAStore } from '../../../actions/PLAStoreAction';
import { getDeliveryZipcode } from '../../../actions/DeliveryZipcodeAction';
import {
    pageLoadReadyScuccess,
    restPageLoadReadyFlag,
    onPageReady,
    pageLoadProductOOS,
} from '../../../actions/AnalyticsAction';
import fromGallery from '../../../actions/FromGalleryAction';
import Regular from './Regular/CommonPDP';
import Bundle from './Bundle/BundleLazy';
import { expandQASection, expandReviews } from '../../../helpers/BazaarVoice';
import selectSkuId from '../../../selectors/selectedByUser/selectSkuId';
import getIrisS1PromoBannerAction from '../../../actions/PromotionalBannerAction';

export class PDPPage extends Component {
    static propTypes = {
        productType: PropTypes.oneOfType([PropTypes.object]),
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        deviceSize: PropTypes.string,
        deviceType: PropTypes.oneOfType([PropTypes.object]),
        match: PropTypes.oneOfType([PropTypes.object]),
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        queryParams: PropTypes.oneOfType([PropTypes.object]),
        inventory: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        urgencyStatements: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        analytics: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedSkuId: PropTypes.string,
        shouldRender: PropTypes.bool,
        isNative: PropTypes.bool,
        nativeAppUserDetails: PropTypes.oneOfType([PropTypes.object]),
        productOffering: PropTypes.object,
        deviceName: PropTypes.string,
        irisShippingThresholds: PropTypes.object,
    };

    static defaultProps = {
        productType: {},
        actions: {},
        location: {},
        deviceSize: '',
        deviceType: {},
        match: {},
        featureFlags: {},
        queryParams: {},
        inventory: [],
        urgencyStatements: {},
        analytics: {},
        selectedSkuId: '',
        shouldRender: true,
        isNative: false,
        nativeAppUserDetails: {},
        productOffering: {},
        deviceName: '',
        irisShippingThresholds: {},
    };

    constructor(props) {
        super(props);
        this.state = { firstLoad: true };
        if (!__SERVER__ && typeof window !== 'undefined') {
            // eslint-disable-next-line no-underscore-dangle
            window.__productDetailsFetched = window.__productDetailsFetched || {};
        }
    }

    componentWillMount() {
        const {
            deviceSize,
            match: {
                params: { ppId },
            },
            location,
            featureFlags,
            actions,
            isNative,
            nativeAppUserDetails,
            deviceName,
        } = this.props;
        const query = makeQuery(location.search);
        const templateType = query.pTmplType;
        const {
            getTTLFromBrowserAPI = false,
            queryParamOnServer,
            enableSSRS1IrisPromoBanner = false,
            enableS1IrisPromoBanner = false,
        } = featureFlags;
        if (!this.props.productDetails || !this.props.productDetails.id) {
            // Prevent duplicate fetches on client-side double mount and showing up 2 calls at debug=noSSR
            if (!__SERVER__ && typeof window !== 'undefined') {
                // eslint-disable-next-line no-underscore-dangle
                if (window.__productDetailsFetched[ppId]) {
                    return;
                }
                // eslint-disable-next-line no-underscore-dangle
                window.__productDetailsFetched[ppId] = true;
            }

            /* eslint-disable no-nested-ternary */
            /* istanbul ignore next */
            this.props.actions.getProductDetailsAction({
                ppid: ppId,
                deviceSize,
                templateType,
                redirectAction: {
                    setRedirectUrl: (redirectData) => ({
                        type: 'SET_REDIRECT_URL',
                        redirectData,
                    }),
                },
                cacheAction: getTTLFromBrowserAPI ? { type: SET_PAGE_CACHE } : null,
            });
            // TODO : should get canonicalUrl dynamically, them moved the logic to the commonjs componentwillmount()
            let canonicalUrl = this.props.productDetails?.meta?.canonicalUrl || location?.pathname;
            canonicalUrl =
                canonicalUrl?.indexOf('?') > -1
                    ? canonicalUrl?.substring(0, canonicalUrl.indexOf('?'))
                    : canonicalUrl;
            const headers = this?.props?.productDetails?.headers;
            if (enableS1IrisPromoBanner && enableSSRS1IrisPromoBanner) {
                this.props.actions.getIrisS1PromoBannerAction({
                    ppId,
                    pTmplType: query.pTmplType,
                    deviceName,
                    canonicalUrl,
                    headers,
                });
            }
        }
        if (queryParamOnServer) {
            actions.getQueryParams(query);
        }
        const { storeId } = query;
        if (!__SERVER__ && isPLAPage(query, 'google', featureFlags) && storeId) {
            // in case of storeId is lesser than 4 digit append 0 till 4 digit see details YODATOF-3184
            const correctedStoreId = padStart(storeId, 4, 0); // in case of
            this.props.actions.updateStoreCookieFromPLAStore({ storeId: correctedStoreId });
        }
        /* istanbul ignore next */
        if (isNative && TokenProvider.get(DP_USER_STATE) === '1') {
            const userEmail = LocalStorage.getData(DP_USER_EMAIL);
            if (isEmpty(userEmail) && isEmpty(nativeAppUserDetails.userEmail)) {
                actions?.getUserEmailFromApp();
            }
        }
    }

    componentDidMount() {
        const { location } = this.props;
        const query = makeQuery(location.search);
        const isFromGallery = LocalStorage.getData('fromGallery');

        if (!this.props.featureFlags.queryParamOnServer) {
            this.props.actions.getQueryParams(query);
        }

        const {
            deviceType,
            queryParams: { bvcontenttype, bvPopUp },
        } = this.props;

        if (isFromGallery) {
            this.props.actions.fromGallery(isFromGallery);
        }

        this.props.actions.getDeliveryZipcode();
        /* istanbul ignore next */
        if ((bvcontenttype && bvcontenttype === 'REVIEW_SUBMISSION') || bvPopUp) {
            expandReviews(deviceType);
        }

        /* istanbul ignore next */
        if (bvcontenttype && bvcontenttype === 'QUESTION_SUBMISSION') {
            expandQASection(deviceType);
        }

        window.addEventListener(
            'load',
            this.props.actions.showLazy.bind(this, 'pageLoaded'),
            false
        );
        this.props.actions.showLazy('pageMounted');
    }

    componentWillReceiveProps(nextProps) {
        const {
            deviceSize,
            featureFlags,
            actions,
            match: {
                params: { ppId },
            },
        } = this.props;
        const query = makeQuery(nextProps?.location?.search);
        const { getTTLFromBrowserAPI = false } = featureFlags;
        /* istanbul ignore next */
        if (nextProps.match.params.ppId !== ppId) {
            // Clear fetch flag for new product
            if (!__SERVER__ && typeof window !== 'undefined') {
                // eslint-disable-next-line no-underscore-dangle
                delete window.__productDetailsFetched[ppId];
            }
            actions.restPageLoadReadyFlag({ pageReadyCmpleted: false });
            actions.resetInventoryAction();
            actions.getProductDetailsAction({
                ppid: nextProps.match.params.ppId,
                deviceSize,
                templateType: query.pTmplType,
                cacheAction: getTTLFromBrowserAPI ? { type: SET_PAGE_CACHE } : null,
            });
            actions.getQueryParams(query);
            actions.productOptionsOnResetAction(false);
        }
    }

    componentDidUpdate() {
        const { urgencyStatements, queryParams, location, featureFlags } = this.props;
        const { enableDigitalDataInventory = true } = featureFlags;
        const query = makeQuery(location.search);
        const isCollectionsClicked = queryParams.cartId ? 'yes' : null;
        const shopLookContainerElement = document.getElementById('shopLookContainer');

        /* istanbul ignore next */
        if (
            this.state.firstLoad &&
            query?.utm_medium === 'email' &&
            query?.utm_content === 'shoplook' &&
            shopLookContainerElement
        ) {
            this.setState({ firstLoad: false });
            const shopLookContainerElementHeight = shopLookContainerElement.offsetTop - 250;
            window.scrollTo(0, shopLookContainerElementHeight);
        }
        if (this.shouldFirePageLoad()) {
            window.onbeforeunload = () => {
                window.scrollTo(0);
            };

            this.props.actions.onPageReady({
                templateType: query.pTmplType,
                collectionView: isCollectionsClicked,
                searchAvailable: query.Ntt,
                inventory: this.props.inventory,
                urgencyStatements,
            });
            this.props.actions.pageLoadReadyScuccess({ pageReadyCmpleted: true });
            enableDigitalDataInventory &&
                this.props.actions.pageLoadProductOOS({
                    templateType: query.pTmplType,
                    collectionView: isCollectionsClicked,
                    searchAvailable: query.Ntt,
                    inventory: this.props.inventory,
                    urgencyStatements,
                });
        }
    }

    /* istanbul ignore next */
    shouldFirePageLoad = () => {
        const {
            urgencyStatements,
            queryParams,
            analytics,
            selectedSkuId,
            productType,
            productOffering,
        } = this.props;
        let flag = !analytics.pageReadyCmpleted && !isEmpty(this.props.inventory);

        /* istanbul ignore next */
        if (flag && (!urgencyStatements || Object.keys(urgencyStatements).length === 0)) {
            flag = false;
        }

        /* istanbul ignore next */
        if (
            flag &&
            (queryParams.selectedSKUId || queryParams.sku) &&
            isEmpty(productOffering) &&
            selectedSkuId &&
            analytics.pageReadyCmpleted &&
            productType.templateType !== 'mtm'
        ) {
            flag = false;
        }
        return flag;
    };

    renderTemplate() {
        const {
            productType: { templateType, isCollection },
            match: {
                params: { ppId },
            },
            featureFlags,
            location,
            queryParams,
            selectedSkuId,
            // eslint-disable-next-line react/prop-types
            userState,
            irisShippingThresholds,
        } = this.props;
        const SpecificTemplate = templateType === 'bundle' ? Bundle : Regular;

        return (
            <ErrorBoundary>
                <SpecificTemplate
                    isCollection={isCollection}
                    ppId={ppId}
                    query={queryParams}
                    featureFlags={featureFlags}
                    location={location}
                    isBeauty={templateType === 'beauty'}
                    updatedSKUId={selectedSkuId}
                    showFreeShipSignIn={
                        templateType !== 'bundle' &&
                        featureFlags?.enableFSHBanner === true &&
                        irisShippingThresholds?.rewardCustomer &&
                        !(userState && userState !== '0')
                    }
                />
            </ErrorBoundary>
        );
    }

    render() {
        const { productDetails, shouldRender, featureFlags, isProtectionModalOpen } = this.props;
        const { disableNarvarShippingProtection = false } = featureFlags;

        return (
            <Layout>
                {shouldRender && productDetails && productDetails.id ? this.renderTemplate() : null}
                {!__SERVER__ &&
                    (isFeatureEnabledFromCookie('enableShippingProtection') ||
                        !disableNarvarShippingProtection) &&
                    isProtectionModalOpen && (
                        <ShippingProtectionModalLazy isOpen={isProtectionModalOpen} />
                    )}
                <MiniPDPInterstitialAsync />
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    productDetails: state.productDetails,
    deviceSize: selectSizeBasedOnDeviceType(state),
    deviceType: selectDeviceType(state),
    productType: selectProductType(false)(state),
    productOffering: state.productOffering || {},
    analytics: state.Analytics,
    featureFlags: state.context ? state.context.featureFlags : {},
    urgencyStatements: state.urgencyStatements,
    inventory: state.inventory,
    queryParams: selectQueryParams(state),
    selectedSkuId: selectSkuId(state),
    shouldRender: selectShouldRender(state),
    isNative: state.context ? state.context.isNative : {},
    nativeAppUserDetails: state.nativeAppUserDetails ? state.nativeAppUserDetails : {},
    irisS1PromotionalBannerData: state?.irisS1PromotionalBannerReducerData || {},
    irisShippingThresholds: state?.irisPromotionalBannerData?.shippingThresholds || {},
    deviceName: selectDeviceName(state),
    isProtectionModalOpen: state.shippingProtectionModal.isModalOpen || false,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...productDetailsAction,
            getIrisS1PromoBannerAction,
            resetInventoryAction,
            showLazy,
            /* Analytics Actions */
            onPageReady,
            pageLoadReadyScuccess,
            restPageLoadReadyFlag,
            /* Delivery Zipcode Actions */
            getDeliveryZipcode,
            /* From Gallery Actions */
            fromGallery,
            /* Product Options Action */
            productOptionsOnResetAction,
            /* Query Params Action */
            getQueryParams,
            updateStoreCookieFromPLAStore,
            getUserEmailFromApp,
            pageLoadProductOOS,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(PDPPage);
